var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-textarea" }, [
    _vm.$slots.default
      ? _c(
          "label",
          { staticClass: "app-textarea__label" },
          [
            _vm.$attrs.required
              ? _c("span", { staticClass: "require-mark" }, [_vm._v("*")])
              : _vm._e(),
            _vm._v(" "),
            _vm._t("default")
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "textarea",
      _vm._g(
        _vm._b(
          {
            staticClass: "app-textarea__input",
            class: { "app-textarea__input--error": _vm.hasError }
          },
          "textarea",
          _vm.$attrs,
          false
        ),
        _vm.inputListener
      )
    ),
    _vm._v(" "),
    _vm.$attrs.maxlength && !_vm.hideCount
      ? _c("p", { staticClass: "app-textarea__max" }, [
          _vm._v("\n\t\t" + _vm._s(_vm.count) + "\n\t")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.hasError
      ? _c("p", { staticClass: "app-textarea__error" }, [
          _vm._v("\n\t\t" + _vm._s(_vm.invalidMessage || _vm.error) + "\n\t")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6307c31e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6307c31e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppTextarea.vue
// module id = null
// module chunks = 